import { AnalyticsContextProvider } from "./AnalyticsContextProvider.tsx";

type PageContextProps = {
  name: string;
  children: React.ReactNode | React.ReactNode[];
};

export const PageContext = ({ name, ...props }: PageContextProps) => {
  return <AnalyticsContextProvider properties={{ page: name }} {...props} />;
};
